import controller from './register.controller';
import template from './register.html';

const storeRegisterComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default storeRegisterComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/register/register.component.js
 **/